import { Modal, Checkbox } from 'antd'

interface AiAgentConsentModalProps {
  open: boolean
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  onOk: () => void
  onCancel: () => void
}

function AiAgentConsentModal({
  open,
  checked,
  onCheckedChange,
  onOk,
  onCancel,
}: AiAgentConsentModalProps) {
  return (
    <Modal
      open={open}
      className='ai-agent-consent-modal'
      width={560}
      onOk={onOk}
      onCancel={onCancel}
      okText='Agree and start chat'
      cancelText='Cancel'
      okButtonProps={{ disabled: !checked }}
      maskClosable={false}
      centered
      title='Before you start: Important information'
    >
      <div className='ai-agent-consent-content'>
        <p>
          AL, LMI Group&apos;s AI assistant, is now available for early Beta access, if you wish to
          participate in the testing and improving AL we welcome your feedback. Please note however
          that while our AI assistant can help summarise, compare, and explain information. It may
          generate inaccuracies or omit context. Use your professional judgement and verify
          important details before making decisions.
        </p>
        <ul className='consent-bullets'>
          <li>Outputs are guidance only, not financial, legal, or insurance advice</li>
          <li>Always review the underlying source documents and policy terms</li>
          <li>We may retain interactions to improve quality and safety</li>
        </ul>
      </div>
      <Checkbox checked={checked} onChange={(e) => onCheckedChange(e.target.checked)}>
        I understand and agree to proceed
      </Checkbox>
    </Modal>
  )
}

export { AiAgentConsentModal }
